/* omn-swatch.js — RAL swatch renderer (RAL General Licence Conditions 2026 §2(2)).
 *
 * RAL colour VALUES (hex) may not be PUBLISHED as a downloadable data table. So the
 * theme's public colour JSONs carry RAL code+name+family+`si` (a sprite index) — never
 * the hex — and the colour itself lives ONLY inside a swatch spritesheet IMAGE
 * (ral-swatches.v1.png), which is a permitted "representation" ("showing swatches is
 * fine"), not a value table. This helper:
 *   • styleFor(si)  → CSS to paint a chip from the sprite cell (no hex needed, async-safe)
 *   • hexSync(si)   → the cell's RGB sampled from the (same-origin) image via canvas, so
 *                     the 3D gel / preview canvas can still be TINTED — using the value to
 *                     render, which is allowed; the value is never re-published as data.
 * BS 4800 is Omnitub's OWN data and keeps its hex in the JSON — it never uses this helper.
 */
(function () {
  'use strict';
  if (window.OmnSwatch) return;
  var URL_ = null, COLS = 46, ROWS = 45;
  var img = null, cv = null, ctx = null, ready = false, cbs = [];

  function cfg(url, cols, rows) {
    if (url) URL_ = url;
    if (cols) COLS = +cols;
    if (rows) ROWS = +rows;
    // Pre-warm the sampling canvas so hexSync() (the 3D/preview tint value) is ready
    // by the time the customer picks — the sprite is tiny and already fetched for the
    // chip backgrounds, so this decode is effectively free.
    if (URL_) load();
  }
  function load() {
    if (img || !URL_) return;
    img = new Image();
    img.decoding = 'async';
    img.crossOrigin = 'anonymous';           // same-origin asset, but explicit keeps canvas untainted
    img.onload = function () {
      try {
        cv = document.createElement('canvas');
        cv.width = img.naturalWidth; cv.height = img.naturalHeight;
        ctx = cv.getContext('2d', { willReadFrequently: true });
        ctx.drawImage(img, 0, 0);
        ready = true;
      } catch (e) { ready = false; }
      var q = cbs; cbs = [];
      q.forEach(function (f) { try { f(); } catch (e) {} });
    };
    img.onerror = function () { var q = cbs; cbs = []; q.forEach(function (f) { try { f(); } catch (e) {} }); };
    img.src = URL_;
  }
  function rc(si) { return { c: si % COLS, r: Math.floor(si / COLS) }; }
  function styleFor(si) {
    if (si == null || !URL_) return 'background:#F4F1EA';
    var p = rc(si);
    var bx = COLS > 1 ? (p.c / (COLS - 1) * 100) : 0;
    var by = ROWS > 1 ? (p.r / (ROWS - 1) * 100) : 0;
    return 'background-image:url(' + URL_ + ');background-repeat:no-repeat;background-size:' +
      (COLS * 100) + '% ' + (ROWS * 100) + '%;background-position:' + bx + '% ' + by + '%';
  }
  function hexSync(si) {
    if (!ready || si == null || !ctx) return null;
    var p = rc(si), cw = cv.width / COLS, ch = cv.height / ROWS;
    var x = Math.floor(p.c * cw + cw / 2), y = Math.floor(p.r * ch + ch / 2);
    try {
      var d = ctx.getImageData(x, y, 1, 1).data;
      return '#' + [d[0], d[1], d[2]].map(function (n) { return ('0' + n.toString(16)).slice(-2); }).join('');
    } catch (e) { return null; }
  }
  // Paint an element's background from the sprite cell WITHOUT clobbering its other
  // inline styles (position, transition, …) — unlike a styleFor() cssText assignment.
  function applyTo(el, si) {
    if (!el) return;
    if (si == null || !URL_) { el.style.backgroundImage = 'none'; el.style.background = '#F4F1EA'; return; }
    var p = rc(si);
    var bx = COLS > 1 ? (p.c / (COLS - 1) * 100) : 0;
    var by = ROWS > 1 ? (p.r / (ROWS - 1) * 100) : 0;
    el.style.backgroundImage = 'url(' + URL_ + ')';
    el.style.backgroundRepeat = 'no-repeat';
    el.style.backgroundSize = (COLS * 100) + '% ' + (ROWS * 100) + '%';
    el.style.backgroundPosition = bx + '% ' + by + '%';
  }
  function onReady(cb) { if (ready) cb(); else { cbs.push(cb); load(); } }
  function hex(si, cb) {
    if (ready) return cb(hexSync(si));
    onReady(function () { cb(hexSync(si)); });
  }

  window.OmnSwatch = {
    cfg: cfg, load: load, styleFor: styleFor, applyTo: applyTo,
    hexSync: hexSync, hex: hex, onReady: onReady,
    isReady: function () { return ready; }
  };
})();
